import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { WEEKS } from "@/data/content";
import { Reveal, MaskReveal, SectionLabel } from "./primitives";

export default function TimelineSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="semanas" className="relative overflow-hidden bg-brand-navy py-24 text-white md:py-32">
      <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="pointer-events-none absolute -right-20 top-20 h-96 w-96 rounded-full bg-brand-gold/12 blur-[120px]" />
      <div className="pointer-events-none absolute -left-20 bottom-20 h-80 w-80 rounded-full bg-brand-blue/25 blur-[130px]" />
      <div className="relative mx-auto max-w-6xl px-5 lg:px-8">
        <div className="mb-14 max-w-3xl">
          <Reveal><SectionLabel dark>AS 8 SEMANAS</SectionLabel></Reveal>
          <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskReveal lines={["8 semanas. Um plano."]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-5 text-base leading-relaxed text-white/60 md:text-lg">
              Clique em cada semana para explorar o conteúdo trabalhado na preparação.
            </p>
          </Reveal>
        </div>

        <div className="relative flex flex-col gap-3">
          {WEEKS.map((week, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={week.n} delay={i * 0.04}>
                <div
                  className={`overflow-hidden rounded-3xl border backdrop-blur-sm transition-[border-color,box-shadow,background-color] duration-300 ${
                    isOpen
                      ? "border-brand-gold/40 bg-white/[0.07] shadow-[0_24px_50px_-24px_rgba(0,0,0,0.4)]"
                      : "border-white/10 bg-white/[0.03] hover:border-white/20 hover:bg-white/[0.06]"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`week-toggle-${week.n}`}
                    className="flex w-full items-center gap-5 px-6 py-5 text-left md:px-8 md:py-6"
                  >
                    <span
                      className={`font-display text-2xl font-semibold tracking-tight transition-colors md:text-3xl ${
                        isOpen ? "gold-gradient-text" : "text-white/25"
                      }`}
                    >
                      {week.n}
                    </span>
                    <span className="mx-1 hidden h-8 w-px bg-white/15 sm:block" />
                    <span className="flex-1">
                      <span className="block text-[10px] font-semibold uppercase tracking-[0.24em] text-brand-gold">
                        Semana {week.n}
                      </span>
                      <span className="mt-0.5 block font-display text-lg font-medium tracking-tight text-white md:text-xl">
                        {week.title}
                      </span>
                    </span>
                    <span
                      className={`grid h-10 w-10 shrink-0 place-items-center rounded-full transition-colors ${
                        isOpen ? "bg-brand-gold text-brand-navy" : "bg-white/10 text-white"
                      }`}
                    >
                      {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="border-t border-white/10 px-6 py-5 text-sm leading-relaxed text-white/65 md:px-8 md:py-6 md:text-base">
                          {week.desc}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
